import React, {useState, useContext, useRef} from 'react'
import { IonInput, IonButton, IonItem, IonList,IonGrid, IonRow, IonCol, IonModal, IonContent } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';

import Cookie from 'universal-cookie';


import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/zPublic.css';

//const { Storage } = Plugins;
let cookie = new Cookie();



export function UpdatePassword (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let passwordRef = useRef(''); 
    let otpRef = useRef('');


    function updateCredentials() {



        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 'update_password',
                //user: acctID,
                xUsername: props.data.username,
                xPassword: passwordRef.current.value
            })
        }

        

        fetch(baseURL+'reset_password', requestOptions)
        .then(res => res.json())
        .then(data => {

            //alert(data);

            if(data == "password_update_confirmed")
            {
                alert('Password Updated')
                props.closeModal(true);
            }
            else
            {
                alert("Password Update Unsuccessful");
            }
           // props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })

    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert('in LoginCredential_merchant');
    //alert(landingPage)

    return (
    

        <React.Fragment>
                {
                props.openModal == true ?
                (
                <IonModal isOpen={ props.openModal }>

                        <IonGrid className='appGridRow_Content'>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonInput type='text' placeholder="Enter New Password" ref={ passwordRef }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    {/*<button onClick={handleConfirmEmployeeLogin}>Login</button>*/}
                                    <IonButton onClick={() => updateCredentials()}>Submit</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                    <IonButton onClick={() => props.closeModal(false)}>Close</IonButton>
                    </IonModal>) : null
}

        </React.Fragment>  
    )
     
}